import { cloneDeep, isEqual, omit } from 'lodash'
import { FlowNodeTypes } from '../types'

/**
 * Fields to ignore when detecting unsaved changes for specific node types
 * These fields are set automatically by forms and shouldn't trigger unsaved changes
 */
const IGNORED_FIELDS: Partial<Record<FlowNodeTypes, string[]>> = {
  [FlowNodeTypes.ai_agent_v2]: ['channel', 'model_config'], // Set automatically based on agentMeta and defaults
  [FlowNodeTypes.ai_agent_v29]: ['channel', 'model_config'],
  [FlowNodeTypes.ai_agent_call]: ['model_config'], // Set automatically based on provider defaults
}

// Filters out ignored fields from data for accurate change detection
export const filterIgnoredFields = <T extends Record<string, unknown>>(
  data: T,
  nodeType: FlowNodeTypes,
): T => {
  const fieldsToIgnore = IGNORED_FIELDS[nodeType]

  let filtered = cloneDeep(data)

  if (fieldsToIgnore && fieldsToIgnore.length > 0) {
    filtered = omit(filtered, fieldsToIgnore) as T
  }

  return filtered
}

/**
 * Compares two objects after filtering out ignored fields
 */
export const compareWithIgnoredFields = <T extends Record<string, unknown>>(
  obj1: T,
  obj2: T,
  nodeType: FlowNodeTypes,
): boolean => {
  const filtered1 = filterIgnoredFields(obj1, nodeType)
  const filtered2 = filterIgnoredFields(obj2, nodeType)
  return isEqual(filtered1, filtered2)
}
